import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a25b0a5a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a25b0a5a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25b0a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a25b0a5a')) {
      api.createRecord('a25b0a5a', component.options)
    } else {
      api.reload('a25b0a5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a25b0a5a&scoped=true&", function () {
      api.rerender('a25b0a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/promotion/index.vue"
export default component.exports